import React, { useEffect, useMemo, useState } from "react";
import { MaterialReactTable } from "material-react-table";
import {
  Box,
  Button,
  IconButton,
  Modal,
  Fade,
  Paper,
} from "@mui/material";
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Campaign as CampaignIcon,
} from "@mui/icons-material";
import axios from "axios";
import toast from "react-hot-toast";
import { URL } from "../config";
import ExtraAdvertisementModal from "./AddExtraAdvertisement";

const ExtraAdvertisementList = () => {
  const [dataSource, setDataSource] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [editAd, setEditAd] = useState(null);

  const fetchExtraAds = async () => {
    const res = await axios.get(`${URL}/extraadvertisements`);
    const formatted = res.data.data.map((item) => ({
      ...item,
      extraAdImage: item.extraAdvertisementImage
        ? `${URL}${item.extraAdvertisementImage}`
        : "",
    }));
    setDataSource(formatted);
  };

  useEffect(() => {
    fetchExtraAds();
  }, []);

  const handleDelete = async (id) => {
    if (!window.confirm("Delete?")) return;
    await axios.delete(`${URL}/extraadvertisements/${id}`);
    toast.success("Deleted");
    fetchExtraAds();
  };

  const columns = useMemo(() => [
    {
      header: "Actions",
      Cell: ({ row }) => (
        <Box sx={{ display: "flex", gap: 1 }}>
          <IconButton onClick={() => {
            setEditAd(row.original);
            setOpenModal(true);
          }}>
            <EditIcon sx={{ color: "#174253" }} />
          </IconButton>
          <IconButton onClick={() =>
            handleDelete(row.original.extraAdvertisementId)
          }>
            <DeleteIcon sx={{ color: "#d32f2f" }} />
          </IconButton>
        </Box>
      ),
    },
    { accessorKey: "extraAdvertisementId", header: "ID" },
    {
      header: "Image",
      Cell: ({ row }) =>
        row.original.extraAdImage ? (
          <img
            src={row.original.extraAdImage}
            style={{ width: 60, height: 60, borderRadius: 8 }}
          />
        ) : (
          <CampaignIcon />
        ),
    },
  ], []);

  return (
    <Box>
    <Box sx={{ width: "100%", bgcolor: "#ffffff", marginTop: 2, p: { xs: 1, md: 0 }, overflow: "hidden" }}>
      
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, pr: 2 }}>
            <Box sx={{ display: "flex", alignItems: "center", fontWeight: 700, fontSize: 22, color: "#174253", letterSpacing: 0.5, borderLeft: "5px solid #174253", pl: 1.5 }}>
              Extra Advertisement List
            </Box>
            <Button
              sx={{
                borderRadius: 25,
                background: "linear-gradient(90deg, #0b8793, #174253)",
                color: "white",
                "&:hover": { background: "linear-gradient(90deg, #174253, #0b8793)" },
              }}
              onClick={() => {
                setEditAd(null);
                 setOpenModal(true);
              }}
            >
              Add Advertisement
            </Button>
          </Box>
    
        
          <Box sx={{ background: "#fff", borderRadius: "0 0 15px 15px" }}>
            <MaterialReactTable
              columns={columns}
              data={dataSource}
              enableColumnActions={false}
              enableDensityToggle={false}
              enableFullScreenToggle={false}
              enableColumnFilters={false}
              enableHiding={false}
              enableGlobalFilter={false}
              muiTablePaperProps={{ sx: { boxShadow: "none", background: "#fff", borderRadius: "15px" } }}
              muiTableContainerProps={{ sx: { backgroundColor: "#fff", width: "100%", overflowX: "auto", borderRadius: "12px" } }}
              muiTableHeadCellProps={{ sx: { backgroundColor: "#e0e0e0ff", color: "#393e4f", fontWeight: 600, fontSize: "16px", borderBottom: "0.5px solid #e3e5eb", textAlign: "left", height: "63px", paddingTop: "23px" } }}
              muiTableBodyRowProps={{ sx: { backgroundColor: "#fff", "&:hover": { backgroundColor: "#eff6fe" }, "& td": { fontSize: { xs: "12px", sm: "14px" }, p: "8px", borderBottom: "0.5px solid #e3e5eb", height: "54px" } } }}
              initialState={{ pagination: { pageIndex: 0, pageSize: 10 } }}
            />
          </Box>
        </Box>

      <Modal open={openModal} onClose={() => setOpenModal(false)}>
        <Fade in={openModal}>
          <Paper>
            <ExtraAdvertisementModal
              ad={editAd}
              onClose={() => {
                setOpenModal(false);
                fetchExtraAds();
              }}
            />
          </Paper>
        </Fade>
      </Modal>
    </Box>
  );
};

export default ExtraAdvertisementList;
